import { Button, ButtonGroup, Grid } from "@material-ui/core";
import React from "react";

export type ToggleButtonProps = {
  list: string[];
  selectedData: string;
  onSelecteData: (data: string) => void;
};

function ToggleButton(props: ToggleButtonProps) {
  return (
    <Grid
      md={6}
      xs={12}
      container
      justifyContent="center"
      alignItems="center"
      style={{ margin: "auto", marginBottom: "2rem" }}
    >
      <ButtonGroup
        color="primary"
        size="large"
        style={{ borderRadius: "20px", background: "#54A4A633" }}
        aria-label="outlined primary button group"
        fullWidth
      >
        {" "}
        {props.list.map((item: string, index: number) => {
          return (
            <Button
              key={index}
              style={{
                borderRadius: "20px",
                fontSize: "1.5rem",
                padding: "1.5rem 2rem",
                border:
                  props.selectedData !== item ? "none" : "1px solid #54A4A6"
              }}
              onClick={() => props.onSelecteData(item)}
              variant={props.selectedData == item ? "contained" : "outlined"}
              fullWidth
            >
              {item}
            </Button>
          );
        })}
      </ButtonGroup>
    </Grid>
  );
}

export default ToggleButton;
